<template>
  <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :show-close="false" @close="handleClose">
    <div class="diaInner" id="diaInner">
      <h3 class="diainner_title">
        盲板抽堵安全作业
        <div class="diainner_title_num">编号：{{ message.no }}</div>
      </h3>
      <table border="1">
        <tr>
          <td class="title" :colspan="2">申请单位</td>
          <td :colspan="2">{{ message.applicant?.contrName }}</td>
          <td class="title" :colspan="2">作业单位</td>
          <td :colspan="3">{{ message.businessJson.content }}</td>
          <!--<td :colspan="3">{{ message.applicant?.content }}</td>
           <td class="title" :colspan="2">申请人</td>
          <td :colspan="6">{{ getUserName(message.applyUserId) }}</td> -->
        </tr>
        <tr>
          <td class="title" :colspan="2">作业类型</td>
          <td :colspan="7">{{ lArr[message.locationId] }}</td>
<!--          <td :colspan="7">{{ lArr[message.applicant?.locationId] }}</td>-->
        </tr>
        <tr>
          <td :rowspan="2" class="title">设备管道名称</td>
          <td :colspan="3" class="title">设备</td>
          <td :colspan="3" class="title">盲板</td>
          <td :rowspan="2" :colspan="2" class="title">实施作业开始时间</td>
        </tr>
        <tr>
          <td class="title">介质</td>
          <td class="title">温度</td>
          <td class="title">压力</td>
          <td class="title">材质</td>
          <td class="title">规格</td>
          <td class="title">编号</td>
          <!-- <td class="title">抽</td>
          <td class="title">堵</td> -->
<!--          <td class="title">抽</td>
          <td class="title">堵</td>
          <td class="title">抽</td>
          <td class="title">堵</td>-->
        </tr>
        <tr>
          <td>{{ message.businessJson.epn }}</td>
          <td>{{ message.businessJson.medium }}</td>
          <td>{{ message.businessJson.temp }}</td>
          <td>{{ message.businessJson.pressure }}</td>
          <td>{{ message.businessJson.bm }}</td>
          <td>{{ message.businessJson.bs }}</td>
          <td>{{ message.businessJson.bn }}</td>
          <!-- <td>{{ message.planStartTime }}</td>
          <td>{{ message.planEndTime }}</td> -->
          <td :colspan="2">{{ message.applyTime }}</td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">盲板位置图及编号:</div>
            <div class="fireplayidea_cont">
              这里还有个图片（断路地段示意图）<br /><!--TODO 缺少附件-->
              {{ message.businessJson.gc }}
            </div>
            <div class="fireplayidea_right">
              <span>签字：{{ getUserName(message.businessJson.signId) }}</span>
              <span>签字时间：{{ message.businessJson.signTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="2" class="title">作业负责人</td>
          <td>{{ getUserName(message.applyUserId) }}</td>
          <td class="title">作业人</td>
          <td :colspan="2">{{ getUserName(message.businessJson.od) }}</td>
          <td class="title">监护人</td>
          <td :colspan="2">{{ getUserName(message.businessJson.oc) }}</td>
        </tr>
<!--         <tr>
          <td class="title" :colspan="2">生产单位作业指挥</td>
          <td :colspan="4" class="keepLeft">{{ message.businessJson.puoc }}</td>
          <td class="title" :colspan="2">作业单位负责人</td>
          <td :colspan="4" class="keepLeft">{{ message.businessJson.cc }}</td>
        </tr>
         <tr>
          <td class="title" :colspan="2">作业单位负责人</td>
          <td :colspan="10" class="keepLeft">{{ message.businessJson.cc }}</td>
        </tr>-->
        <tr>
          <!-- <td class="title" :colspan="2">涉及的其他特殊作业</td>
          <td :colspan="4" class="keepLeft">{{ message.businessJson.oso }}</td>
          <td class="title" :colspan="3">涉及的其他特殊作业安全作业证编号</td>
          <td :colspan="3" class="keepLeft">{{ message.businessJson.oson }}</td> -->
          <td class="title" :colspan="2">关联的其他特殊作业及安全作业票编号</td>
          <td :colspan="7">{{ formatPreWorkInfo() }}</td>
        </tr>
        <tr>
          <td class="title" :colspan="2">风险辨识</td>
          <td :colspan="7" class="keepLeft">{{ message.businessJson.hi }}</td>
        </tr>
<!--        <tr>
          <td class="title" :colspan="2">涉及的其他特殊作业及编号</td>
          <td :colspan="10" class="keepLeft">{{ message.businessJson.oson }}</td>
        </tr>-->
        <tr>
          <td class="title">序号</td>
          <td class="title" :colspan="5">安全措施</td>
          <td class="title" :colspan="2">是否涉及</td>
          <td class="title">确认人</td>
        </tr>
        <tr v-for="(item3, index3) in message.businessJson.sms" :key="index3 + '-' + item3.confirmorId">
          <td>{{ index3 + 1 }}</td>
          <td :colspan="5" class="keepLeft">{{ item3.measures }}</td>
          <td :colspan="2">{{ item3.isInvolve == 3 ? '是' : '否' }}</td>
          <td><i v-html="getSignatureImg(item3.orderNo, 40)" /></td>
        </tr>
        <tr>
          <td :colspan="2" class="title">安全交底人</td>
          <td :colspan="2">{{ getUserName(message.businessJson.aqjdrId) }}</td>
          <td :colspan="2" class="title">接受交底人</td>
          <td :colspan="3">{{ getUserName(message.businessJson.jsjdrId) }}</td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">作业负责人意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.companyChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.companyChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.companyChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">所在单位意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.branchChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.branchChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.branchChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">完工验收意见</div>
            <div class="fireplayidea_cont">{{ message.reviewOpinion }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(0, 60)" /></span>
              <span>签字时间：{{ message.reviewTime }}</span>
            </div>
<!--            <div class="fireplayidea_cont">{{ message.businessJson.approveChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.approveChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.approveChargerTime }}</span>
            </div>-->
          </td>
        </tr>
<!--        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">作业负责人完工确认情况</div>
            <div class="fireplayidea_cont">{{ message.acceptanceOpinion }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(0, 60)" /></span>
              <span>签字时间：{{ message.acceptanceTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">生产车间(分厂)负责人完工确认情况</div>
            <div class="fireplayidea_cont">{{ message.reviewOpinion }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(0, 60)" /></span>
              <span>签字时间：{{ message.reviewTime }}</span>
            </div>
          </td>
        </tr>-->
      </table>
    </div>
    <span slot="footer" class="diaFooter">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button v-if="!isWork" type="primary" v-print="'#diaInner'" size="small">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import signatureImg from "@/assets/img/签字.png";

export default {
  name: 'blindBoard',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array,
      default: []
    },
    message: {
      type: Object,
      default: {}
    },
    isWork: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lArr: ['堵盲板', '抽盲板']
    }
  },
  methods: {
    formatPreWorkInfo() {
      if (!this.message.preWorkInfo) {
        return
      }
      let str = []
      let data = JSON.parse(this.message.preWorkInfo)
      for (var i = 0; i < data.length; i++) {
        let element = data[i]
        str.push(`${element.name}(${element.no})`)
      }
      str = str.join(',')
      return str
    },
    handleClose() {
      this.$emit('componentResult', false)
    },
    getUserName(id) {
      for (let i in this.userList) {
        if (id === this.userList[i].id) {
          return this.userList[i].name
        }
      }
    },

    getSignatureImg(orderNum, height = 40) {
      let signatureImg = require('@/assets/img/签字.png');
      let signatureImgHeight = 'auto';
      for (let i in this.message.reviewContentJson) {
        if (orderNum === this.message.reviewContentJson[i].orderNum) {
          let img = this.message.reviewContentJson[i].signatureImg;
          if (img) {
            signatureImg = img;
            signatureImgHeight = height + 'px'
          }
        }
      }

      return '<img style="height: ' + signatureImgHeight + '" src="' + signatureImg + '"/>';
    },
  }
}
</script>

<style src="./commonTable.css" scoped></style>

<style>
.diaInner {
  width: 1020px;
  margin: auto;
}

table {
  width: 1020px;
}

td {
  width: 200px;
}

.diainner_title {
  text-align: center;
  font-size: 28px;
  position: relative;
}

.diainner_title .diainner_title_num {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 14px;
  font-weight: normal;
}

.fireplayidea_title {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
}

.fireplayidea_cont {
  line-height: 22px;
  text-align: left;
  margin: 10px 0;
}

.fireplayidea_right {
  text-align: right;
}

.fireplayidea_right span {
  margin-left: 10px;
  width: 220px;
  display: inline-block;
  text-align: left;
}
</style>